import { render, staticRenderFns } from "./Team.vue?vue&type=template&id=c7850a22&scoped=true"
import script from "./Team.vue?vue&type=script&lang=js"
export * from "./Team.vue?vue&type=script&lang=js"
import style0 from "./Team.vue?vue&type=style&index=0&id=c7850a22&prod&scoped=true&lang=css"
import style1 from "./Team.vue?vue&type=style&index=1&id=c7850a22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7850a22",
  null
  
)

export default component.exports